import React from "react";
import classNames from "classnames/bind";
import styles from "../ProfilePage.module.scss";
import { Loader2 } from "lucide-react";

const cx = classNames.bind(styles);

const ProfileForm = ({
  formData,
  isEditing,
  isSaving,
  currentTranslations,
  handleInputChange,
  handleEdit,
  handleSave,
  handleCancel,
}) => {
  return (
    <div className={cx("profile-section")}>
      <div className={cx("section-header")}>
        <h2>{currentTranslations?.Profile?.personal_info}</h2>
        {!isEditing ? (
          <button className={cx("edit-btn")} onClick={handleEdit}>
            {currentTranslations?.Profile?.edit}
          </button>
        ) : (
          <div className={cx("action-buttons")}>
            <button
              className={cx("save-btn")}
              onClick={handleSave}
              disabled={isSaving}
            >
              {isSaving ? (
                <>
                  <Loader2 size={14} className={cx("spinner")} />
                  Đang lưu...
                </>
              ) : (
                "Lưu"
              )}
            </button>
            <button
              className={cx("cancel-btn")}
              onClick={handleCancel}
              disabled={isSaving}
            >
              Hủy
            </button>
          </div>
        )}
      </div>

      <div className={cx("form-section")}>
        <div className={cx("form-row")}>
          <div className={cx("form-group")}>
            <label>{currentTranslations?.Authen?.First_name}</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              disabled={!isEditing}
              className={cx("form-input")}
            />
          </div>
          <div className={cx("form-group")}>
            <label>{currentTranslations?.Authen?.Last_name}</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              disabled={!isEditing}
              className={cx("form-input")}
            />
          </div>
        </div>

        <div className={cx("form-row")}>
          <div className={cx("form-group")}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              disabled={!isEditing}
              className={cx("form-input")}
            />
          </div>
          <div className={cx("form-group")}>
            <label>{currentTranslations?.Authen?.Phone}</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              disabled={!isEditing}
              className={cx("form-input")}
            />
          </div>
        </div>

        <div className={cx("form-group")}>
          <label>{currentTranslations?.Profile?.address}</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            disabled={!isEditing}
            className={cx("form-input")}
          />
        </div>

        <div className={cx("form-row")}>
          <div className={cx("form-group")}>
            <label>{currentTranslations?.Profile?.city}</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              disabled={!isEditing}
              className={cx("form-input")}
            />
          </div>
          <div className={cx("form-group")}>
            <label>{currentTranslations?.Profile?.district}</label>
            <input
              type="text"
              name="district"
              value={formData.district}
              onChange={handleInputChange}
              disabled={!isEditing}
              className={cx("form-input")}
            />
          </div>
          <div className={cx("form-group")}>
            <label>{currentTranslations?.Profile?.ward}</label>
            <input
              type="text"
              name="ward"
              value={formData.ward}
              onChange={handleInputChange}
              disabled={!isEditing}
              className={cx("form-input")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileForm;
